<div class="body" [formGroup]="formGroup">

    <div class="sidenav-wrapper">

        <app-sidenav></app-sidenav>

    </div>

    <div @show class="content">

        <div class="issue-transformed-hint incident" *ngIf="incidentConvertedToIssue">

            Dieses Ticket wurde zu einem Vorgang konvertiert. <span class="link"
                (click)="showIssue(incidentConvertedToIssue)">Anzeigen</span>

        </div>

        <div class="issue-transformed-hint issue" *ngIf="issueCreatedFromIncident">

            Dieser Vorgang wurde aus einem Ticket erzeugt. <span class="link"
                (click)="showIssue(issueCreatedFromIncident)">Anzeigen</span>

        </div>

        <div class="section-wrapper" formGroupName="issue">

            <div class="section-headline optional">

                <mat-icon class="main-icon">assignment</mat-icon>

                <span class="text">
                    Kopfdaten
                </span>

                <span class="spacer"></span>

            </div>

            <div class="header">

                <div class="title-wrapper">

                    <div class="main-input-wrapper">
                        <mat-form-field class="width main-input" appearance="outline">
                            <div matPrefix class="number-prefix" (click)="$event.stopPropagation()">
                                {{numberControl.value? numberControl.value: 'neu'}}</div>
                            <mat-label>Titel</mat-label>
                            <input formControlName="issuetitle" matInput />
                            <button mat-icon-button @fade matSuffix color="warn"
                                [disabled]="disabled || !titleControl.value" (click)="clearTitle()">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <app-concurrency-label></app-concurrency-label>

                </div>

                <div class="header-extension">

                    <div class="header-data-wrapper">

                        <app-select-status-form formControlName="issuestate" [appearance]="'outline'">
                        </app-select-status-form>
                        <app-select-category-form formControlName="issuecategory" [appearance]="'outline'">
                        </app-select-category-form>
                        <app-select-priority-form formControlName="issuepriority" [appearance]="'outline'">
                        </app-select-priority-form>

                        <mat-form-field appearance="outline">
                            <mat-label>Wunschdatum</mat-label>
                            <input formControlName="issueescalation" matInput [matDatepicker]="picker" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>

                    </div>

                    <div class="description-wrapper">

                        <mat-form-field class="width" appearance="outline">
                            <mat-label>Beschreibung</mat-label>
                            <textarea formControlName="issuedesc" matInput rows="6"></textarea>
                        </mat-form-field>

                    </div>

                </div>

            </div>
        </div>

        <div class="content-row-3" formGroupName="issue" [class.sidenav-expanded]="sidenavExpanded">

            <div class="widget section-wrapper  customer-widget">

                <div class="section-headline optional">

                    <mat-icon class="main-icon">domain</mat-icon>

                    <span class="text">
                        Kunde und Ansprechpartner
                    </span>

                    <span class="spacer"></span>

                </div>

                <div class="grid-body">

                    <div class="section">

                        <app-select-contact class="input-wrapper" formControlName="commercialcontactpersonalid"
                            [customerSetted]="customerControl.value" [label]="'Geschäftlicher Ansprechpartner'"
                            [appearance]="'outline'">
                        </app-select-contact>

                        <app-contact-label *ngIf="commercialContactControl.value"
                            [contactIdentifier]="commercialContactControl.value"
                            [headline]="'Geschäftlicher Ansprechpartner'" @fade class="contact-label-wrapper"
                            (click)="navigateToContact(commercialContactControl.value)">
                        </app-contact-label>

                    </div>

                    <div class="section">

                        <app-select-contact class="input-wrapper" formControlName="localcontactpersonalid"
                            [customerSetted]="customerControl.value" [label]="'Ansprechpartner vor Ort'"
                            [appearance]="'outline'">
                        </app-select-contact>

                        <app-contact-label *ngIf="localContactControl.value"
                            [contactIdentifier]="localContactControl.value" [headline]="'Ansprechpartner vor Ort'" @fade
                            class="contact-label-wrapper" (click)="navigateToContact(localContactControl.value)">
                        </app-contact-label>

                    </div>

                    <div class="section customer-section">

                        <app-select-customer class="input-wrapper" formControlName="issuecustomer" appearance='outline'>
                        </app-select-customer>

                        <div class="customer-note" *ngIf="customerControl.value"
                            (click)="navigateToCustomer(customerControl.value)">

                            <mat-icon>
                                info
                            </mat-icon>

                            <quill-view [content]="customerControl.value|customerNote|async" format="html" theme="snow"
                                class="issue-customer-note"></quill-view>

                        </div>

                    </div>

                </div>

            </div>

            <div class="widget section-wrapper ">

                <div class="section-headline">

                    <mat-icon class="main-icon">folder</mat-icon>

                    <span class="text">
                        Ordnerstruktur
                    </span>

                    <span class="spacer"></span>

                    <div class="controls" *ngIf="!disabled">

                        <div class="control-button" (click)="uploadFiles()" matTooltip="Datei hochladen">
                            <mat-icon>add</mat-icon>
                        </div>

                        <div class="control-button" (click)="addFolder()" matTooltip="Neuen Ordner erstellen">
                            <mat-icon>create_new_folder</mat-icon>
                        </div>

                        <div class="control-button" [matMenuTriggerFor]="folderMenu">
                            <mat-icon>more_horiz</mat-icon>
                        </div>

                    </div>

                </div>
                <div class="section file-wrapper">

                    <app-nextcloud-folder-explorer formControlName="folderlocation"
                        [view]="issueDetailViewComponentService.nextcloudFolderView"></app-nextcloud-folder-explorer>

                </div>

            </div>

        </div>

        <div class="content-row-3" [class.sidenav-expanded]="sidenavExpanded">

            <div class="widget section-wrapper  user-widget">

                <div class="section-headline">

                    <mat-icon class="main-icon">supervised_user_circle</mat-icon>

                    <span class="text">
                        Nutzer einteilen
                    </span>

                    <span class="spacer"></span>

                </div>

                <div class="assign-user-outer" formArrayName="userAssignments">

                    <div class="assign-user-inner">

                        <app-assign-user-form2 [disabled]="disabled"></app-assign-user-form2>

                    </div>

                </div>

            </div>

            <div class="widget section-wrapper">

                <div class="section-headline">

                    <mat-icon class="main-icon">style</mat-icon>

                    <span class="text">
                        Angebote verwalten
                    </span>

                    <span class="spacer"></span>

                    <div class="controls" *ngIf="!disabled">

                        <div class="control-button" matTooltip="Neues Angebot anlegen" (click)="addOffer()">
                            <mat-icon>add</mat-icon>
                        </div>

                    </div>

                </div>

                <div class="offer-wrapper">

                    <div class="offer-wrapper-outer"
                        *ngIf="(issueDetailViewComponentService.offers$|async)?.length > 0; else noOffers">

                        <app-offer-widget></app-offer-widget>

                    </div>

                    <ng-template #noOffers>

                        <div class="no-offers-hint">Keine Angebote</div>

                    </ng-template>

                </div>

            </div>

        </div>

        <div class="section-wrapper" formArrayName="issueItems" *ngIf="issueTypeHasItems">

            <div class="section-headline">

                <mat-icon class="main-icon">router</mat-icon>

                <span class="text">
                    Vorgangsartikel
                </span>

                <span class="spacer"></span>

                <div class="controls" *ngIf="!disabled">

                    <div *ngIf="formGroup.enabled" class="control-button" (click)="addArticle()"
                        matTooltip="Neuen Artikel anlegen">
                        <mat-icon>add</mat-icon>
                    </div>

                    <div *ngIf="formGroup.enabled" class="control-button" (click)="openItemAssist()"
                        matTooltip="AMS Artikelassistent">
                        <mat-icon>adb</mat-icon>
                    </div>

                </div>

            </div>

            <div class="item-wrapper" *ngIf="!itemsRefreshing" @show>

                <app-issue-items-form2 [disabled]="disabled"></app-issue-items-form2>

            </div>

        </div>

        <div class="content-row-2" formGroupName="issue">

            <div class="widget section-wrapper mail-widget">

                <div class="section-headline">

                    <mat-icon class="main-icon">alternate_email</mat-icon>

                    <span class="text">
                        Korrespondenz
                    </span>

                    <span class="spacer"></span>

                    <div class="control-button" (click)="toggleEMailSidenav = !toggleEMailSidenav">
                        <mat-icon>{{toggleEMailSidenav? 'arrow_right': 'arrow_left'}}</mat-icon>
                    </div>


                </div>

                <div class="e-mail-wrapper">

                    <app-mail-widget [toggled]="toggleEMailSidenav"></app-mail-widget>

                </div>

            </div>

            <div class="widget section-wrapper">

                <div class="section-headline">

                    <mat-icon class="main-icon">edit</mat-icon>

                    <span class="text">
                        Notiz
                    </span>

                    <span class="spacer"></span>

                    <div *ngIf="formGroup.enabled" class="control-button" (click)="convertNote()"
                        matTooltip="Notiz konvertieren">
                        <mat-icon>flip_camera_android</mat-icon>
                    </div>

                </div>

                <div class="note-wrapper">

                    <quill-editor *ngIf="!disabled" formControlName="issuenote" [format]="'html'" class="quill-note"
                        [modules]="modules"></quill-editor>
                    <quill-view *ngIf="disabled" [content]="noteControl.value" [format]="'html'" class="quill-note">
                    </quill-view>

                </div>

            </div>

        </div>

        <div class="widget section-wrapper" style="max-height: unset;"
            *ngIf="(issueDetailViewComponentService.msgFiles$|async)?.length > 0">

            <div class="section-headline">

                <mat-icon class="main-icon">view_carousel</mat-icon>

                <span class="text">
                    Nachrichtenarchiv
                </span>

                <span class="spacer"></span>

                <div class="controls" *ngIf="!disabled">

                    <div class="control-button" (click)="showMsgCollection = !showMsgCollection">
                        <mat-icon>{{showMsgCollection? 'expand_less': 'expand_more' }}</mat-icon>
                    </div>

                </div>

            </div>
            <div class="section msg-preview-wrapper" *ngIf="showMsgCollection">

                <app-msg-collection-view></app-msg-collection-view>

            </div>

        </div>

    </div>

</div>

<mat-menu #folderMenu="matMenu">

    <button mat-menu-item class="dropdown-item" (click)="openNextcloud()">
        <mat-icon class="dropdown-icon">cloud_outline</mat-icon>
        <span>Nextcloud öffnen ...</span>
    </button>

    <button mat-menu-item class="dropdown-item"
        (click)="issueDetailViewComponentService.nextcloudFolderView = issueDetailViewComponentService.nextcloudFolderView === FileViewModes.List? FileViewModes.Tiles: FileViewModes.List">
        <mat-icon class="dropdown-icon">{{issueDetailViewComponentService.nextcloudFolderView === FileViewModes.List?
            'apps': 'list'}}</mat-icon>
        <span>{{issueDetailViewComponentService.nextcloudFolderView === FileViewModes.List? 'Kachelansicht':
            'Listenansicht'}}</span>
    </button>

    <button mat-menu-item class="dropdown-item" (click)="selectNextcloudFolder()">
        <mat-icon class="dropdown-icon">search</mat-icon>
        <span>Ordnerzuweisung ändern</span>
    </button>

    <button [disabled]="!folderlocationControl.value" mat-menu-item class="dropdown-item" (click)="uploadFiles()">
        <mat-icon class="dropdown-icon">upload</mat-icon>
        <span>Datei hochladen</span>
    </button>

    <button [disabled]="!folderlocationControl.value" mat-menu-item class="dropdown-item" (click)="reloadFolder()">
        <mat-icon class="dropdown-icon">refresh</mat-icon>
        <span>Ordner neuladen</span>
    </button>

</mat-menu>